module.exports = __webpack_public_path__ + "img/flit2goLogo.5d785c01.svg";